import { VuexModule, Module, Mutation, Action } from 'vuex-module-decorators'
import api from '@/api'
import { ProductApiModel } from '@/interfaces/ProductApiModel'

@Module({ namespaced: true })
class AllModels extends VuexModule {
  public models: Array<ProductApiModel> = []

  @Mutation
  public saveModels(data: Array<ProductApiModel>): void {
    this.models = data
  }

  @Action
  public loadModels(conf: any): Promise<boolean> {
    return api
      .get('/products/', {
        params: conf
      })
      .then(response => {
        this.context.commit('saveModels', response.data)
        return true
      })
      .catch(() => {
        return false
      })
  }
}
export default AllModels
